import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'

import elAfZA from 'element-ui/lib/locale/lang/af-ZA'
import elAr from 'element-ui/lib/locale/lang/ar'
import elAz from 'element-ui/lib/locale/lang/az'
import elBg from 'element-ui/lib/locale/lang/bg'
import elBn from 'element-ui/lib/locale/lang/bn'
import elCa from 'element-ui/lib/locale/lang/ca'
import elCsCZ from 'element-ui/lib/locale/lang/cs-CZ'
import elDa from 'element-ui/lib/locale/lang/da'
import elDe from 'element-ui/lib/locale/lang/de'
import elEe from 'element-ui/lib/locale/lang/ee'
import elEl from 'element-ui/lib/locale/lang/el'
import elEn from 'element-ui/lib/locale/lang/en'
import elEo from 'element-ui/lib/locale/lang/eo'
import elEs from 'element-ui/lib/locale/lang/es'
import elEu from 'element-ui/lib/locale/lang/eu'
import elFa from 'element-ui/lib/locale/lang/fa'
import elFi from 'element-ui/lib/locale/lang/fi'
import elFr from 'element-ui/lib/locale/lang/fr'
import elHe from 'element-ui/lib/locale/lang/he'
import elHr from 'element-ui/lib/locale/lang/hr'
import elHu from 'element-ui/lib/locale/lang/hu'
import elHyAM from 'element-ui/lib/locale/lang/hy-AM'
import elId from 'element-ui/lib/locale/lang/id'
import elIs from 'element-ui/lib/locale/lang/is'
import elIt from 'element-ui/lib/locale/lang/it'
import elJa from 'element-ui/lib/locale/lang/ja'
import elKg from 'element-ui/lib/locale/lang/kg'
import elKm from 'element-ui/lib/locale/lang/km'
import elKo from 'element-ui/lib/locale/lang/ko'
import elKu from 'element-ui/lib/locale/lang/ku'
import elKz from 'element-ui/lib/locale/lang/kz'
import elLt from 'element-ui/lib/locale/lang/lt'
import elLv from 'element-ui/lib/locale/lang/lv'
import elMn from 'element-ui/lib/locale/lang/mn'
import elMs from 'element-ui/lib/locale/lang/ms'
import elNbNO from 'element-ui/lib/locale/lang/nb-NO'
import elNl from 'element-ui/lib/locale/lang/nl'
import elPl from 'element-ui/lib/locale/lang/pl'
import elPtBr from 'element-ui/lib/locale/lang/pt-br'
import elPt from 'element-ui/lib/locale/lang/pt'
import elRo from 'element-ui/lib/locale/lang/ro'
import elRuRU from 'element-ui/lib/locale/lang/ru-RU'
import elSi from 'element-ui/lib/locale/lang/si'
import elSk from 'element-ui/lib/locale/lang/sk'
import elSl from 'element-ui/lib/locale/lang/sl'
import elSrLatn from 'element-ui/lib/locale/lang/sr-Latn'
import elSr from 'element-ui/lib/locale/lang/sr'
import elSvSE from 'element-ui/lib/locale/lang/sv-SE'
import elSw from 'element-ui/lib/locale/lang/sw'
import elTa from 'element-ui/lib/locale/lang/ta'
import elTh from 'element-ui/lib/locale/lang/th'
import elTk from 'element-ui/lib/locale/lang/tk'
import elTrTR from 'element-ui/lib/locale/lang/tr-TR'
import elUa from 'element-ui/lib/locale/lang/ua'
import elUgCN from 'element-ui/lib/locale/lang/ug-CN'
import elUzUZ from 'element-ui/lib/locale/lang/uz-UZ'
import elVi from 'element-ui/lib/locale/lang/vi'
import elZhCN from 'element-ui/lib/locale/lang/zh-CN'
import elZhTW from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(VueI18n)

/**
 * 项目 langCode → Element UI locale 完整映射
 * 新增语言时：只需在此表添加一行即可，未匹配的自动 fallback 英文
 */
const elementLocaleMap = {
  // 项目自定义 langCode
  zh: elZhCN,
  hk: elZhTW,
  // Element UI 原生 langCode（全量预映射）
  'af-ZA': elAfZA, af: elAfZA,
  ar: elAr,
  az: elAz,
  bg: elBg,
  bn: elBn,
  ca: elCa,
  'cs-CZ': elCsCZ, cs: elCsCZ,
  da: elDa,
  de: elDe,
  ee: elEe,
  el: elEl,
  en: elEn,
  eo: elEo,
  es: elEs,
  eu: elEu,
  fa: elFa,
  fi: elFi,
  fr: elFr,
  he: elHe,
  hr: elHr,
  hu: elHu,
  'hy-AM': elHyAM, hy: elHyAM,
  id: elId,
  is: elIs,
  it: elIt,
  ja: elJa,
  kg: elKg,
  km: elKm,
  ko: elKo,
  ku: elKu,
  kz: elKz,
  lt: elLt,
  lv: elLv,
  mn: elMn,
  ms: elMs,
  'nb-NO': elNbNO, nb: elNbNO,
  nl: elNl,
  pl: elPl,
  'pt-br': elPtBr,
  pt: elPt,
  ro: elRo,
  'ru-RU': elRuRU, ru: elRuRU,
  si: elSi,
  sk: elSk,
  sl: elSl,
  'sr-Latn': elSrLatn,
  sr: elSr,
  'sv-SE': elSvSE, sv: elSvSE,
  sw: elSw,
  ta: elTa,
  th: elTh,
  tk: elTk,
  'tr-TR': elTrTR, tr: elTrTR,
  ua: elUa, uk: elUa,
  'ug-CN': elUgCN, ug: elUgCN,
  'uz-UZ': elUzUZ, uz: elUzUZ,
  vi: elVi,
}

/**
 * 自动加载 lang 目录下所有 .json 文件
 * 文件名映射规则：zh-CN.json → zh, zh-HK.json → hk, 其余直接用文件名
 */
const langFiles = require.context('@/common/lang', false, /\.json$/)
const messages = {}

const fileNameToLangCode = (fileName) => {
  // fileName 格式: ./zh-CN.json
  const name = fileName.replace('./', '').replace('.json', '')
  switch (name) {
    case 'zh-CN': return 'zh'
    case 'zh-HK': return 'hk'
    default: return name
  }
}

langFiles.keys().forEach(key => {
  const langCode = fileNameToLangCode(key)
  const langData = langFiles(key)
  const elLocale = elementLocaleMap[langCode] || elEn
  messages[langCode] = Object.assign({}, langData, elLocale)
})

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

const i18n = new VueI18n({
  locale: 'en',
  messages
})

export default i18n